import { useEffect, useState } from "react";
import { Label } from "../../components/ui/label";
import { API, http } from "./booking-shared";

/* ---------- Step 3: Schedule (live availability) ---------- */
export function StepSchedule({ o, set, conflictTick }) {
  const [avail, setAvail] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    http.get(`${API}/availability`, { params: { days: 45 } }).then((r) => setAvail(r.data)).catch(() => setAvail(null)).finally(() => setLoading(false));
  }, [conflictTick]);

  const openDates = (avail?.dates || []).filter((d) => d.any_open).slice(0, 24);
  const selected = (avail?.dates || []).find((d) => d.date === o.shoot_date);
  return (
    <div data-testid="step-schedule">
      <h2 className="font-display text-2xl text-[#4A0000]">Pick a date & time</h2>
      <p className="text-sm text-[#5C5A58] mt-1 mb-4">Choose an open day, then a time that works.</p>
      {loading ? <p className="text-sm text-[#5C5A58]" data-testid="avail-loading">Loading open dates…</p>
        : !avail ? <p className="text-sm text-[#5C5A58]">Couldn't load live availability. Please try again or contact us below.</p>
        : (
        <>
          <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1" data-testid="shoot-date">
            {openDates.map((d) => (
              <button key={d.date} data-testid={`avail-date-${d.date}`} onClick={() => set({ shoot_date: d.date, time_window: "" })}
                className={`shrink-0 w-16 rounded-lg border py-2 flex flex-col items-center transition ${o.shoot_date === d.date ? "border-[#4A0000] bg-[#4A0000] text-white" : "border-[#E9DDC6] bg-white text-[#1A1715] hover:border-[#B08D57]"}`}>
                <span className="text-[10px] uppercase tracking-wide opacity-70">{d.weekday}</span>
                <span className="font-display text-xl leading-none my-0.5">{d.day}</span>
                <span className="text-[10px] uppercase opacity-70">{d.month}</span>
              </button>
            ))}
          </div>
          {selected && (
            <div className="mt-4">
              <Label className="text-xs text-[#5C5A58]">Start time <span className="text-[#8A8782]">· 7:00 AM–5:00 PM ET, ~2 hours for a standard shoot</span></Label>
              <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 mt-1.5 max-h-56 overflow-y-auto pr-1" data-testid="time-window">
                {selected.windows.map((w, i) => (
                  <button key={w.window} data-testid={`avail-window-${i}`} disabled={w.full} onClick={() => !w.full && set({ time_window: w.window })}
                    className={`rounded-lg border py-2 px-1 text-center text-sm font-medium transition disabled:opacity-40 disabled:cursor-not-allowed ${o.time_window === w.window ? "border-[#4A0000] bg-[#4A0000] text-white" : "border-[#E9DDC6] bg-white text-[#1A1715] hover:border-[#B08D57]"}`}>
                    {w.window}
                  </button>
                ))}
              </div>
            </div>
          )}
          {!selected && <p className="text-xs text-[#8A8782] mt-3">Select a date to see open times.</p>}
        </>
      )}
    </div>
  );
}
